import { render, staticRenderFns } from "./MedicalTestsContainer.vue?vue&type=template&id=7b89f382"
import script from "./MedicalTestsContainer.vue?vue&type=script&lang=js"
export * from "./MedicalTestsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports